import { create } from 'zustand';
import { api, clearTokens, setTokens, getAccessToken } from './api';

export interface User {
  id: string;
  nome: string;
  sobrenome: string | null;
  email: string;
  roleCode: string | null;
  status: string;
  mfaEnabled: boolean;
  lastLoginAt: string | null;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  login: (email: string, senha: string) => Promise<void>;
  logout: () => Promise<void>;
  fetchMe: () => Promise<void>;
  hydrate: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: false,
  error: null,

  login: async (email, senha) => {
    set({ loading: true, error: null });
    try {
      const data = await api<{ accessToken: string; refreshToken: string; user: User }>('/auth/login', {
        method: 'POST',
        body: { email, senha },
        skipAuth: true,
      });
      setTokens(data.accessToken, data.refreshToken);
      set({ user: data.user, loading: false });
    } catch (err: any) {
      set({ error: err?.apiError?.message ?? 'Falha no login', loading: false });
      throw err;
    }
  },

  logout: async () => {
    try {
      const rt = localStorage.getItem('abase.refreshToken');
      if (rt) await api('/auth/logout', { method: 'POST', body: { refreshToken: rt } }).catch(() => {});
    } finally {
      clearTokens();
      set({ user: null });
    }
  },

  fetchMe: async () => {
    try {
      const me = await api<User>('/auth/me');
      set({ user: me });
    } catch {
      clearTokens();
      set({ user: null });
    }
  },

  hydrate: async () => {
    if (getAccessToken()) {
      try {
        const me = await api<User>('/auth/me');
        set({ user: me });
      } catch {
        clearTokens();
        set({ user: null });
      }
    }
  },
}));
